import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { checkAuth } from "../utils/authGuard";
import PageLoader from "../components/common/PageLoader";

interface Props {
  children: React.ReactNode;
}

export default function PublicRoute({ children }: Props) {

  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {

    const verify = async () => {
      const result = await checkAuth();
      setIsAuth(result);
    };

    verify();

  }, []);

  if (isAuth === null) return <PageLoader/>;

  if (isAuth) return <Navigate to="/dashboard" />;

  return <>{children}</>;
}